import { Link, NavLink, useNavigate } from "react-router-dom";
import { BookOpen, Library, Wand2, MessageCircle, Star, LogOut, Crown } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

const links = [
  { to: "/bibliotheque", label: "Bibliothèque", icon: Library, id: "nav-library-link" },
  { to: "/creer", label: "Créer", icon: Wand2, id: "nav-create-link" },
  { to: "/atelier", label: "Atelier", icon: MessageCircle, id: "nav-atelier-link" },
  { to: "/profil", label: "Mes progrès", icon: Star, id: "nav-profile-link" },
];

export default function NavBar() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  return (
    <header className="sticky top-0 z-40 border-b-2 border-[color:var(--line)] bg-[#FFFBF2]/85 backdrop-blur-md">
      <div className="mx-auto flex max-w-7xl items-center gap-4 px-4 py-3 sm:px-8">
        <Link to={user ? "/bibliotheque" : "/"} data-testid="nav-brand-link" className="flex items-center gap-2">
          <span className="grid h-10 w-10 place-items-center rounded-2xl bg-[color:var(--terracotta)] text-white wobble">
            <BookOpen size={22} />
          </span>
          <span className={`whitespace-nowrap font-display text-2xl font-bold tracking-tight ${user ? "hidden sm:inline" : ""}`}>Lis-Moi<span className="text-[color:var(--terracotta)]">!</span></span>
        </Link>
        {user && (
          <nav className="ml-auto flex items-center gap-1 sm:gap-2">
            {links.map(({ to, label, icon: Icon, id }) => (
              <NavLink key={to} to={to} data-testid={id}
                className={({ isActive }) => `flex items-center gap-1.5 rounded-full px-3 py-2 text-sm font-bold transition-colors ${isActive ? "bg-[color:var(--espresso)] text-[color:var(--paper)]" : "hover:bg-[color:var(--paper-2)]"}`}>
                <Icon size={18} /><span className="hidden md:inline">{label}</span>
              </NavLink>
            ))}
            {user.is_premium ? (
              <span data-testid="nav-premium-badge" title="Premium" className="grid h-9 w-9 place-items-center rounded-full text-white" style={{ background: "linear-gradient(135deg,#F6B343,#E59819)" }}><Crown size={18} /></span>
            ) : (
              <Link to="/premium" data-testid="nav-premium-link" className="flex items-center gap-1.5 rounded-full bg-[color:var(--sun)] px-3 py-2 text-sm font-extrabold transition-transform hover:scale-105">
                <Crown size={18} /><span className="hidden sm:inline">Premium</span>
              </Link>
            )}
            <button data-testid="nav-logout-button" title="Se déconnecter"
              onClick={async () => { await logout(); navigate("/"); }}
              className="ml-1 rounded-full p-2 text-[color:var(--muted-ink)] transition-colors hover:bg-[color:var(--paper-2)]">
              <LogOut size={18} />
            </button>
          </nav>
        )}
        {user === false && (
          <div className="ml-auto flex items-center gap-2">
            <a href="/#tarifs" data-testid="nav-pricing-link" className="rounded-full px-3 py-2 text-sm font-bold hover:bg-[color:var(--paper-2)]">Tarifs</a>
            <Link to="/connexion" data-testid="nav-login-link" className="btn-ghost !py-2 text-sm">Espace Parents</Link>
          </div>
        )}
      </div>
    </header>
  );
}
